import React from 'react';
import Logo from '../../assets/img/Logo2.png';
import Omino from '../../assets/img/signin.svg';
import Book from '../../assets/img/book.svg';
import { Link } from 'react-router-dom';
import Remove from '../../general-functions/removeborder';
import './styles.css'

function Navbar() {
    return (
        <div id="nav" style={{ height: '70px' }}>
            <nav className="navbar navbar-expand-lg navbar-light " >
                <a className="navbar-brand" href="/mappa"><img style={{ width: '80px' }} src={Logo} alt="Discompose logo" /></a>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav mx-auto">

                        <li className="nav-item">
                            <a className="nav-link font-style-ml center uno" style={{ textAlign: 'center', fontFamily: 'Montserrat', fontSize: '18px', color: '#313131' }} href="/mappa">Map </a>
                        </li>
                        <li className="nav-item">
                            <Link className="remove-underline nav-link font-style-ml due " style={{ textAlign: 'center', fontFamily: 'Montserrat', fontSize: '18px', color: '#313131' }} to="/database" onClick={Remove}>
                                List
                            </Link>

                        </li>
                    </ul>
                    <ul className="navbar-nav" style={{ marginRight: "50px" }} >
                       <li className="nav-item nav-icon" style={{ marginLeft: "120px" }}>
                           <a href="http://www.discompose.unina.it/onboarding"> <img src={Book} style={{ width: '25px' }} className="icon" alt="book icon"></img></a>
                            <a className="nav-link marginBottom-icon onCollapse  " style={{ fontFamily: 'Montserrat', fontSize: '10px', color: '#313131' }} href="http://www.discompose.unina.it/onboarding">How to read</a>
                        </li> 
                        <li className="nav-item nav-icon">
                        <a href="http://www.discompose.unina.it/dashboard"><img src={Omino} style={{ width: '20px' }} className="icon" alt="user icon"></img></a>
                            <a className="nav-link marginBottom-icon onCollapse  " style={{ fontFamily: 'Montserrat', fontSize: '10px', color: '#313131', marginTop: '2px' }} href="http://www.discompose.unina.it/dashboard">
                                Sign In
                            </a>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>



    );
}

export default Navbar;

/*
        <nav className="navbar navbar-expand-lg navbar-light" >
            <a className="navbar-brand" href="/">
                <img className="discompose" src={Logo} alt="Discompose logo" />
            </a>
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <ul className="navbar-nav navbar-nav mx-auto ">

                    <li className="nav-item">
                        <a className="nav-link font-style-ml center uno" style={{ textAlign: 'center', fontFamily: 'Montserrat', fontSize: '24px', color: '#313131' }} href="/#">Map</a>
                    </li>

                    <li className="nav-item">
                    <Link className="remove-underline nav-link font-style-ml due" style={{ textAlign: 'center', fontFamily: 'Montserrat', fontSize: '24px', color: '#313131' }} to="/database" onClick={Remove}>
                                          List
                                      </Link>
                 
                    </li>
                </ul>

                <ul className="navbar-nav ml-auto" style={{ marginRight: "50px" }}>
                    <li className="nav-item">
                        <img src={Book} style={{ textAlign: 'center', width: '35px' }} className="icons" alt="book icon"></img>
                        <a className="nav-link onCollapse fontstyle-book-user mb-icon" style={{ fontFamily: 'Montserrat', fontSize: '10px', color: '#313131' }} href="#">How to read</a>
                    </li>
                    <li className="nav-item">
                        <img src={Omino} style={{ textAlign: 'center', width: '35px' }} className="icons user-width" alt="user icon"></img>
                        <Link className="nav-link onCollapse fontstyle-book-user mb-icon " style={{ fontFamily: 'Montserrat', fontSize: '10px', color: '#313131' }} to="/signin">
                            Sign in/Sign Up
                        </Link>
                    </li>
                </ul>
            </div>
        </nav>
*/

